enum SourceSubclient {
    POWERSPORTS_APP_V2 = 'powersports_app_2',
    RV_APP_2 = 'rv_app_2',
}

export default SourceSubclient
